import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';

import { isAssigned } from '../../data';
import { DataFieldComponent } from '../../data/components/data-field/data-field.component';
import { SaveCancelButtonsComponent } from '../../shared/save-cancel-buttons/save-cancel-buttons.component';

@Component({
    selector: 'app-user-context-role-scope-profile-denied-confirm',
    templateUrl: './user-context-role-scope-profile-denied-confirm.component.html',
    styleUrls: ['./user-context-role-scope-profile-denied-confirm.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, InputTextModule, DataFieldComponent, SaveCancelButtonsComponent],
    providers: [DynamicDialogRef],
})
export class UserContextRoleScopeProfileDeniedConfirmComponent {
    deniedReason?: string;
    message: string;
    deniedReasonLabel: string;

    constructor(private readonly _dialogCfg: DynamicDialogConfig) {
        this.message = this._dialogCfg.data?.message ?? 'Enter the Denied Reason';
        this.deniedReasonLabel = this._dialogCfg.data?.deniedReasonLabel ?? 'Denied Reason';
    }

    get isDenyValidated() {
        return isAssigned(this.deniedReason) && this.deniedReason !== '';
    }

    onCancel() {
        this._dialogCfg.data?.doCancel();
    }

    onSave() {
        this._dialogCfg.data?.doAccept(undefined, this.deniedReason);
    }
}
